// ---------------------------------------------------------------------------
// YouAreYou (uru) — ProtectedRoute
//
// Wrapper component for routes that require authentication.
// - While auth status is "loading", shows a minimal loading spinner.
// - If "unauthenticated", redirects to /login (preserving the intended
//   destination in location state so we can redirect back after login).
// - If "authenticated", renders the child route via <Outlet />.
// ---------------------------------------------------------------------------

import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import LogoSpinner from "@/components/ui/LogoSpinner";

function LoadingScreen() {
  return (
    <div className="flex min-h-dvh items-center justify-center bg-background-light">
      <LogoSpinner size="lg" label="Checking authentication…" />
    </div>
  );
}

export default function ProtectedRoute() {
  const { status } = useAuth();
  const location = useLocation();

  if (status === "loading") {
    return <LoadingScreen />;
  }

  if (status === "unauthenticated") {
    // Preserve the page the user was trying to reach so we can redirect
    // back after a successful login.
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Authenticated — render the nested route tree
  return <Outlet />;
}
